// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-list-move[data-v-b5cf5466] {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.alert-list-enter-active[data-v-b5cf5466],\n.alert-list-leave-active[data-v-b5cf5466] {\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.alert-list-enter[data-v-b5cf5466],\n.alert-list-leave-to[data-v-b5cf5466] {\n  opacity: 0;\n  -webkit-transform: translateX(30px);\n          transform: translateX(30px);\n}\n", ""]);
// Exports
module.exports = exports;
